import { setAZMFilterPathToSessionStorage } from "@modules/global/filter-path/filter-path-handler.ts"
import { insertAllAdvertBanners } from "@modules/news/advert-banners.ts"
import { getUrlParam, removePartialUrlParam, updatePartialUrlParam } from "@modules/news/urlParams/url-param.ts"
import type { ApiFiltersResult } from "@modules/types"
import { isPC } from "@modules/util/device.ts"
import { dispatchGlobalEvent } from "@modules/util/events"
import { updateLinks } from "@modules/util/update-links"
import { updateUrl } from "@modules/util/url"
import { updateAdvertCardContainerUI, updateAdvertResultsFoundInfoInDom } from "../global/advert-card-container.ts"
import { advertNewsCardsContainerElement } from "../global/dom.ts"
import { getNextPage, setPagination, updatePaginationButtons, updatePaginationSelect } from "./pagination/pagination"
import { resetAdvertsForUserAndNotify } from "./snapshot-updated-notification"

export function removeSamePageContent() {
    if (isPC()) {
        const container = advertNewsCardsContainerElement()
        if (container) {
            container.innerHTML = ""
        }
        return
    }
    const pageStartElement = advertNewsCardsContainerElement()?.querySelector(`#page-section-${getNextPage() - 1}`)
    let nextElement = pageStartElement?.nextElementSibling
    while (continueRemovingSamePageElement(nextElement)) {
        const oldEl = nextElement
        nextElement = nextElement?.nextElementSibling
        oldEl?.remove()
    }
    pageStartElement?.remove()
}

export function continueRemovingSamePageElement(el: Element | null | undefined) {
    if (!el) {
        return false
    }
    return !el.id.includes("page-section")
}

export async function afterApiFetched(
    filterApiResult: ApiFiltersResult | undefined,
    options: { insertAdjacentHTML?: InsertPosition; removeSamePageContent?: boolean } = {},
) {
    if (!filterApiResult) {
        return
    }
    dispatchGlobalEvent("news.filter-api.after-fetch", filterApiResult)
    const advertCardsContainerEl = advertNewsCardsContainerElement()
    if (advertCardsContainerEl) {
        await new Promise((resolve) =>
            requestAnimationFrame(() => {
                if (options.removeSamePageContent) {
                    removeSamePageContent()
                }
                if (options.insertAdjacentHTML) {
                    advertCardsContainerEl.insertAdjacentHTML(options.insertAdjacentHTML, filterApiResult.content)
                } else {
                    advertCardsContainerEl.innerHTML = filterApiResult.content
                }
                resolve(null)
            }),
        )
    }

    updateAdvertCardContainerUI(filterApiResult.advertCount) //TODO ??
    updateUrl(updateUrlDifferentPageParamsIntoUrl(filterApiResult.seoUrl))
    setPagination(filterApiResult.pagination)
    updatePaginationButtons(filterApiResult.pagination)
    updatePaginationSelect(filterApiResult.pagination)
    updateAdvertResultsFoundInfoInDom(filterApiResult)
    updateLinks()
    insertAllAdvertBanners(true)

    setAZMFilterPathToSessionStorage(filterApiResult, "news")

    SiteInfo.endsWithLastAdvertInGroup = filterApiResult.endsWithLastAdvertInGroup || false
    SiteInfo.currentSearchHash = filterApiResult.currentSearchHash || ""

    SiteInfo.seoHrefPreviousUrl = filterApiResult.seoHrefPreviousUrl || ""
    SiteInfo.seoHrefNextUrl = filterApiResult.seoHrefNextUrl || ""

    updateLoadNextAdvertsButtonHrefFromString(SiteInfo.seoHrefNextUrl)
    updateLoadPreviousAdvertsButtonHrefFromString(SiteInfo.seoHrefPreviousUrl)

    if (filterApiResult.snapshotUpdatedDueToNewDay || filterApiResult.snapshotUpdatedDueToNewIndex) {
        resetAdvertsForUserAndNotify()
    }
}

function updateUrlDifferentPageParamsIntoUrl(filterApiSeoUrl: string): string {
    const newsPageSectionParam = getUrlParam("page", filterApiSeoUrl)
    let newUrl = filterApiSeoUrl

    //information Announcement News Page Addition
    const currentUrlSearchParams = new URLSearchParams(window.location.search)
    if (currentUrlSearchParams.get("information-page") && newsPageSectionParam !== "") {
        newUrl = updatePartialUrlParam(
            window.location.pathname + "?" + currentUrlSearchParams.toString(),
            "page",
            newsPageSectionParam,
        )
    } else if (newsPageSectionParam === "") {
        newUrl = removePartialUrlParam(window.location.pathname + "?" + currentUrlSearchParams.toString(), "page")
    }

    return newUrl
}
function updateLoadNextAdvertsButtonHrefFromString(seoHrefNextUrl: string) {
    document.querySelector("#news-page-seo-href-next")?.setAttribute("href", seoHrefNextUrl)
    document.querySelector("#news-page-seo-href-next-bottom")?.setAttribute("href", seoHrefNextUrl)
}
function updateLoadPreviousAdvertsButtonHrefFromString(seoHrefPreviousUrl: string) {
    document.querySelector("#news-page-seo-href-previous")?.setAttribute("href", seoHrefPreviousUrl)
    document.querySelector("#news-page-seo-href-previous-bottom")?.setAttribute("href", seoHrefPreviousUrl)
}
